@if (mode === 'list') {
  @if (canChangeDoorSide) {
    <div class="radioButtons show-layouts">
      @if (layoutSides.arrWL.length || !hideLayoutWhenUnavailable) {
        <div matRipple (click)="changedDoorSide('W_L')" [class.selected]="doorSide === 'W_L'">
          <div class="img">
            <img src="/application/dist/web/img/layouts/default/drzwi_lewe_do_wewnatrz.jpg">
          </div>
          <p><a>{{ 'DOOR|Drzwi lewe otwierane do wewnątrz' | translate }}</a></p>
        </div>
      }
      @if (layoutSides.arrWR.length || !hideLayoutWhenUnavailable) {
        <div matRipple (click)="changedDoorSide('W_R')" [class.selected]="doorSide === 'W_R'">
          <div class="img">
            <img src="/application/dist/web/img/layouts/default/drzwi_prawe_do_wewnatrz.jpg">
          </div>
          <p><a>{{ 'DOOR|Drzwi prawe otwierane do wewnątrz' | translate }}</a></p>
        </div>
      }
      @if (layoutSides.arrZL.length || !hideLayoutWhenUnavailable) {
        <div matRipple (click)="changedDoorSide('Z_L')" [class.selected]="doorSide === 'Z_L'">
          <div class="img">
            <img src="/application/dist/web/img/layouts/default/drzwi_lewe_do_zewnatrz.jpg">
          </div>
          <p><a>{{ 'DOOR|Drzwi lewe otwierane do zewnątrz' | translate }}</a></p>
        </div>
      }
      @if (layoutSides.arrZR.length || !hideLayoutWhenUnavailable) {
        <div matRipple (click)="changedDoorSide('Z_R')" [class.selected]="doorSide === 'Z_R'">
          <div class="img">
            <img src="/application/dist/web/img/layouts/default/drzwi_prawe_do_zewnatrz.jpg">
          </div>
          <p><a>{{ 'DOOR|Drzwi prawe otwierane do zewnątrz' | translate }}</a></p>
        </div>
      }
    </div>
  }
  <icc-list
    [items]="defaultLayouts"
    itemTemplate="itemImgTitle"
    itemImgHeight="medium"
    (select)="selectWindowSashesLayout($event)"
    [selected]="selectedLayoutId"
  ></icc-list>
}
@if (mode === 'details') {
  <mat-card appearance="outlined" class="mat-elevation-z3">
    <mat-card-header>
      <div mat-card-avatar class="layout-box-img" id="handles-layout-draw" #parent [ngClass]="{'flip-symbols': flipSymbols}">
        <icc-draw
          [details]="drawService.details"
          fitTo="width"
          iccDrawResize
          [options]="drawOptions"
          [drawWidth]="drawService.details.width"
          [drawHeight]="drawService.details.height"
          [parentElement]="parent"
        ></icc-draw>
      </div>
      <mat-card-title class="layout-box-title">{{ (layout$ | async)?.name }}</mat-card-title>
      <mat-card-subtitle class="buttons">
        <button mat-raised-button color="primary" [disabled]="isLayoutSelectionDisabled()" (click)="mode = 'list'">
          {{ 'INTERFACE|Zmień' | translate }}
        </button>
        @if (!(allowMirrorLayout || showEditLayoutInOptions())) {
          <button mat-raised-button color="primary" (click)="editLayout()">
            {{ 'WINDOW|Edycja konstrukcji' | translate }}
          </button>
        }
        @if (showDefaultLayoutButton()) {
          <button mat-raised-button color="primary" (click)="setDefaultLayout()">
            {{ 'WINDOW|Przywróć poprzedni układ' | translate }}
          </button>
        }
        @if (allowMirrorLayout) {
          <button mat-raised-button color="primary" (click)="mirrorLayout()">
            {{ 'WINDOW|Odbicie lustrzane funkcji kwater' | translate }}
          </button>
        }
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      @if (canBeBalcony()) {
        <mat-radio-group
          class="balcony"
          [ngModel]="balcony"
          (ngModelChange)="changeBalcony($event)"
          >
          <mat-radio-button [value]="false">{{ 'WINDOW|Okno' | translate }} </mat-radio-button>
          <mat-radio-button [value]="true"
            >{{ 'WINDOW|Okno balkonowe' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      }
      @if ((lowThresholds0$ | async)) {
        <div class="lowThreshold">
          {{ 'WINDOW|Niski próg' | translate }}:
          <mat-slide-toggle
            [ngModel]="hasThreshold()"
            (ngModelChange)="switchLowThreshold($event)">
          </mat-slide-toggle>
        </div>
      }
      @if ((lowThresholds1$ | async)) {
        <div>
          @for (lowThreshold of lowThresholds; track lowThreshold) {
            <mat-radio-group
              class = "lowThreshold-list"
              [ngModel]='selectedLowThresholdId$ | async'
              (ngModelChange)="changeLowThreshold($event)"
              >
              <mat-radio-button
                [value]="lowThreshold.id">
                {{lowThreshold.name}}
              </mat-radio-button>
            </mat-radio-group>
          }
        </div>
      }
    </mat-card-content>
  </mat-card>
  @if ((isRenoFrames || isMonoblockFrames) && canBeTrimmed) {
    <form class="monoblock mat-elevation-z3" [ngFormOptions]="{updateOn: 'change'}">
      @if (isRenoFrames) {
        <span class ="renoFrame">{{ 'WINDOW|Rama renowacyjna' | translate }}:</span>
      }
      @if (isRenoFrames && !isCircle && commonFinWidths.length) {
        <span class="allFin">
          <mat-checkbox id="reno" name="hasreno" [(ngModel)]="oneFinWidth" (change)="onChangeOneFinWidth()">{{ 'WINDOW|Wszystkie boki przycięte na jedną szerokość' | translate }}</mat-checkbox>
        </span>
      }
      @if (isRenoFrames) {
        <span class="allFin">
          <b>{{ 'WINDOW|Przycięcie ramy do szerokości' | translate }}</b>
          @if (oneFinWidth) {
            <span class ="allFinInput">
              <span >{{ 'WINDOW|Wszystkie boki' | translate }}:</span>
              @if (!commonFinWidth.finWidthInterval) {
                <input iccDimensionInput name="oneFinWidth" type="number" (change)="onChangeOneFinWidth()" [(ngModel)]="frameSides[0].finWidth" [max]="this.oneMaxFinWidth" [min]="this.oneMinFinWidth"><br>
                <small>{{ 'WINDOW|Minimalna wartość {min}, maksymalna wartość {max}' | translate: {min: this.oneMinFinWidth, max: this.oneMaxFinWidth} }}</small>
              }
              @if (commonFinWidth.finWidthInterval) {
                <mat-select name="oneFinWidth" (ngModelChange)="frameSides[0].finWidth = $event; onChangeOneFinWidth()"  [(ngModel)]="frameSides[0].finWidth">
                  @for (width of commonFinWidths; track width) {
                    <mat-option [value]="width">{{ width | unitmm:0:0 }}</mat-option>
                  }
                </mat-select>
              }
              <!-- {{$root.user.dimension_unit}} -->
            </span>
          }
        </span>
      }
      @if (isRenoFrames && !oneFinWidth) {
        <span class="oneFin">
          @for (side of frameSides; track side; let index = $index) {
            @if (side.type === 'reno' && side.canBeTrimmed) {
              <span>
                @if (side.side.side == 'bottom') {
                  <span>{{ 'WINDOW|Dół' | translate }}:</span>
                }
                @if (side.side.side == 'left') {
                  <span>{{ 'WINDOW|Bok lewy' | translate }}:</span>
                }
                @if (side.side.side == 'left-top') {
                  <span>{{ 'WINDOW|Bok lewy górny' | translate }}:</span>
                }
                @if (side.side.side == 'right') {
                  <span>{{ 'WINDOW|Bok prawy' | translate }}:</span>
                }
                @if (side.side.side == 'right-top') {
                  <span>{{ 'WINDOW|Bok prawy górny' | translate }}:</span>
                }
                @if (side.side.side == 'top') {
                  <span>{{ 'WINDOW|Góra' | translate }}:</span>
                }
                @if (!side.profile.finWidthInterval) {
                  <input [name]="'finWidth' + side.side.side" iccDimensionInput type="number" (change)="onChangeRenoDimensions(index)"  [(ngModel)]="side.finWidth" [max]="side.maxFinWidth" [min]="side.minFinWidth"><br>
                  <small>{{ 'INTERFACE|Minimalna wartość {min}, maksymalna wartość {max}' | translate: {min: side.minFinWidth, max: side.maxFinWidth} }}</small>
                }
                @if (side.profile.finWidthInterval) {
                  <mat-select [name]="'finWidth' + side.side.side" (ngModelChange)="side.finWidth = $event; onChangeRenoDimensions(index)" [ngModel]="side.finWidth">
                    @for (width of side.finWidths; track width) {
                      <mat-option [value]="width">
                        {{ width | unitmm:0:0 }}
                      </mat-option>
                    }
                  </mat-select>
                }
              </span>
            }
            <!-- {{$root.user.dimension_unit}} -->
          }
        </span>
      }
      <!-- MONOBLOKOWA -->
      @if (isMonoblockFrames) {
        <span class="monoblock mat-elevation-z3">
          <b>{{ 'WINDOW|Rama monoblokowa' | translate }}:</b>
          @for (side of frameSides; track side; let index = $index) {
            @if (side.type === 'monoblock') {
              <span>
                @if (side.side.side == 'bottom') {
                  <span>{{ 'WINDOW|Dół' | translate }}:</span>
                }
                @if (side.side.side == 'left') {
                  <span>{{ 'WINDOW|Bok lewy' | translate }}:</span>
                }
                @if (side.side.side == 'left-top') {
                  <span>{{ 'WINDOW|Bok lewy górny' | translate }}:</span>
                }
                @if (side.side.side == 'right') {
                  <span>{{ 'WINDOW|Bok prawy' | translate }}:</span>
                }
                @if (side.side.side == 'right-top') {
                  <span>{{ 'WINDOW|Bok prawy górny' | translate }}:</span>
                }
                @if (side.side.side == 'top') {
                  <span>{{ 'WINDOW|Góra' | translate }}:</span>
                }
                <div class="iccSelect">
                  <select
                    [ngModel]="side.id"
                    (ngModelChange)="onChangeRenoDimensions(index)"
                    >
                  </select>
                </div>
              </span>
            }
          }
        </span>
      }
    </form>
  }
}
